import { VueConstructor } from "vue";
import { Component, Vue } from "vue-property-decorator";
import { KeyPress } from '@/utils/keypress';

export type FrameStore<T extends new(...args: any[]) => any> = ReturnType<InstanceType<T>["frameStore"]>

@Component
export class ModuleBase extends Vue {
  get outlet(): { [name: string]: VueConstructor<Vue> | Array<VueConstructor<Vue>> } {
    return {}
  }

  get keypress(): KeyPress[] {
    return []
  }

  frameStore(): any {
    return {}
  }

  persistent = null as any
}
